import { DonorShieldAliasType, IDonorShieldDirect } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: {
        type: DonorShieldAliasType,
        email: string,
        alias: string
    },
    onCancel: (show: boolean) => void
}

const DonorShieldAliasCheck = (props: IProps) => {
    if (props.data == null)
        return null;

    let { type, email, alias } = props.data;

    let donorType = type == DonorShieldAliasType.DonorShieldDirect ? `Donor Shield Direct Donor` : `Donor`;

    return (
        <Modal backdrop='static' show={props.show} onHide={() => props.onCancel(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Record Found</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ textAlign: 'center', marginBottom: 10, color: 'red' }}>{`${donorType} already exists`}</div>
                <div style={{display: 'flow-root', textAlign: 'center'}}>
                    <h4>
                        <span style={{margin: '5px'}}>
                            <strong>
                                Alias:
                            </strong>
                        </span>
                        <span>
                            {alias}
                        </span>
                    </h4>
                </div>
                <div style={{display: 'flow-root', textAlign: 'center'}}>
                    <h4>
                        <span style={{margin: '5px'}}>
                            <strong>
                                Email: 
                            </strong>
                        </span>
                        <span>
                            {email}
                        </span>
                    </h4>
                </div>
                <div style={{display: 'flow-root', textAlign: 'center', color: 'red'}}>
                    <h4>
                        <strong>
                            Please delete other entry if you wish to proceed
                        </strong>
                    </h4>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => props.onCancel(false)}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DonorShieldAliasCheck;